module.exports = __webpack_public_path__ + "img/success.cf5963d.png";